module.exports = __webpack_public_path__ + "static/media/national-aquarium.3c8e6e21.jpg";